module.exports = __webpack_public_path__ + "img/image_correction_before.c09d5fc1.png";